var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeech(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "37px",
    height: "33px",
    viewBox: "0 0 37 33",
    enableBackground: "new 0 0 37 33",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M2,11.083c-1.104,0-2,0.896-2,2v6.167c0,1.104,0.896,2,2,2s2-0.896,2-2v-6.167 C4,11.979,3.104,11.083,2,11.083z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M35,11.083c-1.104,0-2,0.896-2,2v6.167c0,1.104,0.896,2,2,2s2-0.896,2-2v-6.167 C37,11.979,36.104,11.083,35,11.083z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M28.4,4.083c-1.104,0-2,0.896-2,2V26.25c0,1.104,0.896,2,2,2s2-0.896,2-2V6.083 C30.4,4.979,29.505,4.083,28.4,4.083z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M21.8,6.083c-1.104,0-2,0.896-2,2V24.25c0,1.104,0.896,2,2,2s2-0.896,2-2V8.083 C23.8,6.979,22.904,6.083,21.8,6.083z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M15.2,0c-1.104,0-2,0.896-2,2v28.25c0,1.104,0.896,2,2,2s2-0.896,2-2V2C17.2,0.896,16.305,0,15.2,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M8.6,7.083c-1.104,0-2,0.896-2,2V23.25c0,1.104,0.896,2,2,2s2-0.896,2-2V9.083 C10.6,7.979,9.705,7.083,8.6,7.083z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeech);
export default __webpack_public_path__ + "static/media/speech.301c5d80b1999e6614f94392a1e37bc3.svg";
export { ForwardRef as ReactComponent };